import React, { useState } from "react";
import "./Contact.css";
import Header from "./Header";
import FAQSection from "./FAQSection";
import Footer from "./Footer";
import { FaCalendarAlt, FaChevronDown } from "react-icons/fa";
import { motion } from "framer-motion";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const Contact = () => {
  const API_BASE_URL =
    process.env.REACT_APP_API_URL || "http://localhost:8000";
  const IMAGE_BASE_URL = process.env.REACT_APP_IMAGE_BASE_URL;

  const [isSubmitting, setIsSubmitting] = useState(false); // 👈 spinner state

  const containerVariants = {
    hidden: {},
    visible: {
      transition: { staggerChildren: 0.15 },
    },
  };

  const itemVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: {
      opacity: 1,
      y: 0,
      transition: { duration: 0.6, ease: "easeOut" },
    },
  };
  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true); // start spinner
    const form = e.target;
    const formData = new FormData(e.target);
    const data = Object.fromEntries(formData.entries());

    try {
      const response = await fetch(`${API_BASE_URL}/send-mail`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(data),
      });

      const result = await response.json();

      if (result.success) {
        toast.success("Your visit request has been sent successfully!");

        // ✅ Reset all form fields manually for full control
        form.reset(); // resets text, email, textarea etc.

        // ✅ Also reset select and date manually (since reset doesn't always clear them)
        const selects = form.querySelectorAll("select");
        selects.forEach((select) => (select.selectedIndex = 0));

        const dateInput = form.querySelector('input[name="date"]');
        if (dateInput) dateInput.value = "";
      } else {
        toast.error("Something went wrong. Please try again.");
      }
    } catch (err) {
      console.error("❌ Error:", err);
      toast.warn("Error sending message.");
    } finally {
      setIsSubmitting(false); // stop spinner
    }
  };

  return (
    <>
      <Header />

      <section
        className="contact-section"
        style={{ padding: "80px 0 100px 0" }}
      >
        {/* MAP BACKGROUND */}
        <div className="kimi map-container">
          <iframe
            title="Google Map"
            src="https://www.google.com/maps/embed?pb=!1m23!1m12!1m3!1d113085.54963969436!2d77.30015275575632!3d27.657840737744408!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!4m8!3e6!4m0!4m5!1s0x397317002b023c97%3A0x1bcb3b8fb0a44155!2sM95M%2B42V%2C%20Barsana%2C%20Uttar%20Pradesh%20281405!3m2!1d27.6578651!2d77.3825542!5e0!3m2!1sen!2sin!4v1761655947196!5m2!1sen!2sin"
            width="100%"
            height="400"
            style={{ border: 0, top: "0" }}
            allowFullScreen=""
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
          ></iframe>
        </div>

        {/* CONTACT CARD */}
        <div className="contact-wrapper">
          <motion.div
            className="container contact-box shadow rounded p-4 bg-white"
            variants={containerVariants}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: false, amount: 0.3 }}
          >
            {/* Title row */}
            <motion.div
              className="row justify-content-center text-center mb-5"
              variants={itemVariants}
            >
              <div className="col-lg-6">
                <div className="subtitle s2 mb-3">Contact Us</div>
                <h2 className="mb-0">Schedule a Visit</h2>
              </div>
            </motion.div>

            <motion.div
              className="row justify-content-center gy-4"
              variants={itemVariants}
            >
              {/* Agent Info */}
              <motion.div
                className="col-md-6 text-center"
                variants={itemVariants}
              >
                <motion.img
                  // src="/image/real.png"
                  src={`${IMAGE_BASE_URL}/real.png`}
                  alt="Agent"
                  className="img-fluid rounded kirchi mb-3"
                  style={{
                    height: "300px",
                    width: "300px",
                    objectFit: "cover",
                  }}
                />
                <motion.h5 className="mb-1" variants={itemVariants}></motion.h5>
                <motion.div className="fw-400 id-color" variants={itemVariants}>
                  +91 7900304949
                </motion.div>
              </motion.div>

              {/* Form */}
              <motion.div className="col-md-6" variants={itemVariants}>
                <motion.form
                  name="bookingForm"
                  id="booking_form"
                  onSubmit={handleSubmit}
                  variants={containerVariants}
                  initial="hidden"
                  whileInView="visible"
                  viewport={{ once: false, amount: 0.3 }}
                >
                  <div className="row gy-3">
                    <motion.div className="col-md-6" variants={itemVariants}>
                      <input
                        type="text"
                        name="name"
                        className="form-control"
                        placeholder="Your Name"
                        required
                      />
                    </motion.div>

                    <motion.div className="col-md-6" variants={itemVariants}>
                      <input
                        type="email"
                        name="email"
                        className="form-control"
                        placeholder="Your Email"
                        required
                      />
                    </motion.div>

                    <motion.div
                      className="col-md-6 position-relative date-picker"
                      variants={itemVariants}
                    >
                      {/* <FaCalendarAlt className="icon" /> */}
                      <input
                        type="date"
                        name="date"
                        className="form-control"
                        placeholder="Select Date"
                        required
                      />
                    </motion.div>

                    <motion.div
                      className="col-md-6 position-relative select-wrapper"
                      variants={itemVariants}
                    >
                      <select name="time" className="form-control" required>
                        {[
                          "10:00",
                          "11:00",
                          "12:00",
                          "13:00",
                          "14:00",
                          "15:00",
                          "16:00",
                          "17:00",
                          "18:00",
                          "19:00",
                          "20:00",
                        ].map((t) => (
                          <option key={t} value={t}>
                            {t}
                          </option>
                        ))}
                      </select>
                      <FaChevronDown className="icon" />
                    </motion.div>

                    <motion.div className="col-md-12" variants={itemVariants}>
                      <textarea
                        name="message"
                        className="form-control h-150px"
                        placeholder="Submit Request"
                        required
                      ></textarea>
                    </motion.div>

                    <motion.div className="col-md-12" variants={itemVariants}>
                      <button id="btn-main" type="submit" className="btn">
                        {isSubmitting ? (
                          <div className="spinner"></div>
                        ) : (
                          "Send Message"
                        )}
                      </button>
                    </motion.div>
                  </div>
                </motion.form>
              </motion.div>
            </motion.div>
          </motion.div>
        </div>
      </section>

      <FAQSection />
      <Footer />
    </>
  );
};

export default Contact;
